export enum CollapseBreakpoint {
    SINGULAR = 'singular',
    TINY = 'tiny',
    SMALL = 'small',
    DEFAULT = 'default',
    HUGE = 'huge',
}

export const TOOLTIP_OFFSET = 18;
export const TOOLTIP_DELAY = 0;
